import { Image } from 'components/atoms/Image.tsx';
import { Icon } from 'components/atoms/Icon.tsx';

export type Props = { categoryImage?: string; categoryName: string };

export function CategoryItemImage({ categoryImage, categoryName }: Props) {
	return categoryImage ? (
		<Image
			src={categoryImage}
			alt={categoryName}
			className="h-6 md:h-8 mr-3 flex-shrink-0 mix-blend-multiply object-contain aspect-square"
		/>
	) : (
		<Icon type="no_photography" fill className="position-absolute text-[#D2D4D6] mr-3" size={32} />
	);
}
